import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';

import { NumericInlineInputComponent, ResourceImageDirective } from '@mitsubishi/shared/ui';

import { NgSelectModule } from '@ng-select/ng-select';
import { provideFormlyCore } from '@ngx-formly/core';

import { types } from './types';
import { wrappers } from './wrappers';
import { TableWrapperCellComponent } from './wrappers/table-wrapper/table-wrapper-cell/table-wrapper-cell.component';

@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    
    NgSelectModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    FormsModule,
    TableWrapperCellComponent,
    NumericInlineInputComponent,
    ResourceImageDirective,
  ],
  providers: [
    provideFormlyCore({
      wrappers: wrappers,
      types: types,
    }),
  ],
})
export class ApmFormlyModule {}
